import { Dispatch } from "redux";
import { setLoading } from "./global";
import GeneralSettingService from "service/GeneralSetting";
import { showMessage } from "utilities/helper";
import { GeneralSettingPayloadTypes } from "utilities/types/GeneralSetting";

export const getAllGeneralSettings =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterCategory: string = "",
    filterTenant: number = 3
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_GENERAL_SETTING_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_GENERAL_SETTING",
      searchValue: search,
    });

    try {
      const data = await GeneralSettingService.getAllGeneralSettings(
        page,
        search,
        limit,
        filterCategory,
        filterTenant
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_GENERAL_SETTING", value: data.settings });
      dispatch({
        type: "SET_GENERAL_SETTING_PAGE",
        totalPage: !!data.settings.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.settings.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_GENERAL_SETTING_FILTER_PAGE",
        filterCategoryPage: filterCategory,
        filterTenantPage: filterTenant,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeGeneralSetting =
  (form: GeneralSettingPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await GeneralSettingService.storeGeneralSetting(payload);
      const {
        currentPage,
        searchValue,
        limitPage,
        filterCategoryPage,
        filterTenantPage,
      } = getState().generalSettingReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllGeneralSettings(
          currentPage,
          searchValue,
          limitPage,
          filterCategoryPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateGeneralSetting =
  (
    generalSettingId: string,
    form: GeneralSettingPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await GeneralSettingService.updateGeneralSetting(
        generalSettingId,
        payload
      );
      const {
        currentPage,
        searchValue,
        limitPage,
        filterCategoryPage,
        filterTenantPage,
      } = getState().generalSettingReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllGeneralSettings(
          currentPage,
          searchValue,
          limitPage,
          filterCategoryPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteGeneralSetting =
  (generalSettingId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await GeneralSettingService.deleteGeneralSetting(
        generalSettingId
      );
      const {
        currentPage,
        searchValue,
        limitPage,
        filterCategoryPage,
        filterTenantPage,
      } = getState().generalSettingReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });

      dispatch(
        getAllGeneralSettings(
          currentPage,
          searchValue,
          limitPage,
          filterCategoryPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error:", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const getAllGeneralSettingCategories =
  () => async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FILTER_LOADING", value: true });

    try {
      const data = await GeneralSettingService.getAllGeneralSettingCategories();

      dispatch({ type: "SET_FILTER_LOADING", value: false });
      dispatch({
        type: "SET_GENERAL_SETTING_CATEGORY",
        value: data.setting_categories,
      });
    } catch (err: any) {
      dispatch({ type: "SET_FILTER_LOADING", value: false });
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };
